/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_No_ResultsInputs */

const vi_customer_no_results = /** @type {(inputs: Customer_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy`)
};

/**

* @param {Customer_No_ResultsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_no_results = /** @type {((inputs?: Customer_No_ResultsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_No_ResultsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_no_results(inputs)
});